import type { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterComp, IFilterParams } from 'ag-grid-community';
import { TechnicianTour } from "../../../_models/technician-tour.model";
import { WPTechnician } from "../../../_models/technician.interface";

export class TechnicianTourFilter implements IFilterComp<WPTechnician & { tour: TechnicianTour }> {
  filterParams!: IFilterParams;
  onTourFilter: boolean = false;
  unusedTimeFilter: boolean = false;
  absenceFilter: boolean = false;
  gui!: HTMLDivElement;

  init(params: IFilterParams) {
    this.filterParams = params;
    this.setupGui(params);
  }

  // not called by AG Grid, just for us to help setup
  setupGui(params: IFilterParams) {
    this.gui = document.createElement('div');
    this.gui.innerHTML = `
      <div class="person-filter">
        <div style="display: inline-flex; flex-direction: column; flex-wrap: nowrap; margin: 6px;">
          <div style="display: inline-flex; flex-direction: row; margin-right: auto;">
            <input type="checkbox" id="on_tour_checkbox" style="margin: auto;"/>
            <label style="display: flex; flex-direction: row; margin: auto 0 auto 4px;" for="on_tour_checkbox">
              <div class="on_tour technician_status"></div> <div style="margin: auto;"> Unterwegs </div>
            </label>
          </div>
          <div style="display: inline-flex; flex-direction: row; margin-right: auto;">
            <input type="checkbox" id="unused_time_checkbox" style="margin: auto;"/>
            <label style="display: flex; flex-direction: row; margin: auto 0 auto 4px;" for="unused_time_checkbox">
              <div class="unused_time technician_status"></div> <div style="margin: auto;"> Ungenutzte Zeit </div>
            </label>
          </div>
          <div style="display: inline-flex; flex-direction: row; margin-right: auto;">
            <input type="checkbox" id="absence_checkbox" style="margin: auto;"/>
            <label style="display: flex; flex-direction: row; margin: auto 0 auto 4px;" for="absence_checkbox">
              <div class="absence technician_status"></div> <div style="margin: auto;"> Abwesenheit </div>
            </label>
          </div>
        </div>
      </div>
    `;

    const on_tour_listener = (event: any) => {
      this.onTourFilter = event.target.checked;
      params.filterChangedCallback();
    };

    const unused_time_listener = (event: any) => {
      this.unusedTimeFilter = event.target.checked;
      params.filterChangedCallback();
    };

    const absence_listener = (event: any) => {
      this.absenceFilter = event.target.checked;
      params.filterChangedCallback();
    };

    this.gui.querySelector('#on_tour_checkbox').addEventListener('change', on_tour_listener);
    this.gui.querySelector('#unused_time_checkbox').addEventListener('change', unused_time_listener);
    this.gui.querySelector('#absence_checkbox').addEventListener('change', absence_listener);
  }

  getGui() {
    return this.gui;
  }

  doesFilterPass(params: IDoesFilterPassParams<WPTechnician & { tour: TechnicianTour, day_absence: string }>) {
    const { node } = params;

    let passed = true;
    if (this.onTourFilter && !node.data.day_operations.length) {
      passed = false;
    }

    if (this.absenceFilter && !node.data.day_absence) {
      passed = false;
    }

    if (this.unusedTimeFilter && (node.data.day_absence || (node.data.tour?.tourRoute && node.data.tour.tourRoute.hours.unused_capacity_hours == 0))) {
      passed = false
    }

    return passed;
  }

  isFilterActive() {
    return this.onTourFilter || this.absenceFilter || this.unusedTimeFilter;
  }

  getModel() {
    return
  }

  setModel(model: any) {
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {
  }
}
